import { InputAPI } from '@philips-internal/oswald-ui-components';
import moment from 'moment';
import { ISO_FULL_DATE_FORMAT } from '../constants/date-utils';
import timeService from '../services/time-service';

export class TimeUtils {
  static setDateToInput(input: InputAPI): Promise<string> {
    return timeService.getCurrentDateTime()
      .then(dateString => {
        input.setValue(dateString);
        return Promise.resolve(dateString);
      })
      .catch(() => {
        const date = moment().format(ISO_FULL_DATE_FORMAT);
        input.setValue(date);
        return Promise.resolve(date);
      })
  }
}
